import React from 'react';
import {updateSharedRecord, deleteSharedRecord} from '../../services/SharedExperimentService'
import { Link } from "react-router-dom";

class SharedToUserRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.id,
            email: props.email,
            rights: props.rights,
            blockUpdate: props.rights === "OWNER",
            jwtToken: props.jwtToken
        };
        this.handleDelete = this.handleDelete.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.updateParentTable = this.updateParentTable.bind(this);
    }

    updateParentTable(){
        this.props.handler()
    }

    handleUpdate(){
        if (this.state.rights === "OWNER"
               && !window.confirm('Are you sure you want to transfer ownership of this experiment?\nThe experiment will be no longer accessible.')){
            return;
        }
        updateSharedRecord(this.state.jwtToken, this.state.id, this.state.rights)
        .then(response =>
            {
                if (response.ok){
                    if (this.state.rights === "OWNER"){
                        alert("Ownership transferred, redirecting to main page.");
                        window.location.pathname = "/";
                    } else {
                        alert("User rights have been updated");
                        this.updateParentTable();
                    }
                }
                else {
                    alert("Changes could not be saved");
                }
            }
        );
    }

    handleDelete(){
        if (window.confirm('Are you sure you want stop sharing this experiment with user:\n"' + this.state.email + '" ?')) {
            deleteSharedRecord(this.state.jwtToken, this.state.id)
            .then(response =>
                {
                    if (!response.ok){
                        alert("Changes could not be saved");
                    }
                    else {
                        this.updateParentTable();
                    }
                }
            );
        }
    }

    handleInputChange = (e) => {
        if (e.target.name === "rights") {
            this.setState({ rights: e.target.value});
        }
    };

    render() {
        return (
        <>
            <tr>
                <td style={{paddingTop: "13px"}}>{this.state.email}</td>
                <td>
                    <div>
                        <select className="form-control" name="rights" onChange={(e) => this.handleInputChange(e)}
                                style={{float: "left", marginRight: "15px", width: "80%"}} value={this.state.rights}
                                disabled={this.state.blockUpdate}>
                            <option value="VIEW">View allowed</option>
                            <option value="EDIT">View and edit allowed</option>
                            <option value="SHARE">View, edit and sharing allowed</option>
                            {(!this.state.blockUpdate) ?
                                <option value="OWNER">Transfer ownership to user</option>
                                : <option value="OWNER">Owner</option>
                            }
                        </select>
                        {(!this.state.blockUpdate) ?
                            <Link to={"#"}>
                                <span style={{paddingTop: "8px"}}
                                    title="Edit rights" onClick={this.handleUpdate} className="glyphicon glyphicon-edit" />
                            </Link> :
                            <span style={{paddingTop: "8px"}} title="Edit not allowed" className="glyphicon glyphicon-edit" />
                        }
                    </div>
                </td>
                <td>
                    {(!this.state.blockUpdate) ?
                        <Link to={"#"}>
                            <span style={{paddingTop: "8px"}}
                                title="Remove user" onClick={this.handleDelete} className="glyphicon glyphicon-trash" />
                        </Link> :
                        <span style={{paddingTop: "8px"}} title="Removal not allowed" className="glyphicon glyphicon-trash" />
                    }
                </td>
            </tr>
        </>
        );
    }
}

export default SharedToUserRow;